(() => {
  if (window.cardWishlistInit) return;
  window.cardWishlistInit = true;
  let count = 0;
  let queued = false;
  const init = () => {
    const sdk = window.WishListHero_SDK;
    if (!sdk || typeof sdk.InitializeAddToWishListButton !== 'function') return false;
    document.querySelectorAll('[data-card-wishlist]:not([data-card-wishlist-ready])').forEach((el) => {
      el.setAttribute('data-card-wishlist-ready', '');
      count += 1;
      const className = `card-wishlist-${count}`;
      el.classList.add(className);
      el.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
      sdk.InitializeAddToWishListButton({
        WishlistHash: '',
        ButtonClassElement: className,
        ProductId: el.dataset.productId,
        ProductLink: el.dataset.productLink,
        ProductVariantId: el.dataset.variantId,
        ProductPrice: el.dataset.price,
        ProductTitle: el.dataset.title,
        ProductImage: el.dataset.image,
        ButtonMode: 'icon_only',
      });
    });
    return true;
  };
  const start = () => {
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (init() || tries > 60) clearInterval(timer);
    }, 250);
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        init();
      });
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
